import { CookieStorage } from "cookie-storage";

enum CookiesKeys {
  TokenKey = "tokenKey",
  StyleKey = "styleKey"
}
export const cookieStorage = new CookieStorage({
  path: "/",
  secure: false, // No usar Secure en localhost (porque es HTTP)
  sameSite: "Lax" // Evita bloqueos en navegadores
});


export const cookieAvailable = (cookieKey: string, cookieValue: string) => {
  return cookieStorage.getItem(cookieKey) === cookieValue;
};

export default CookiesKeys;
